
import {
  SELECT_SHIPPING_METHOD,
  SHIPPING_METHODS_UPDATED,
  SHIPPING_METHODS_ARE_VALID
} from '../../GlobalStateContainer'

export const ShippingOptions = function (state = [], action) {
  switch (action.type) {
    case SHIPPING_METHODS_UPDATED:
      return action.methods;
    default: 
      return state;
  }
}

export const SelectedShippingOptionId = function (state = '', action) {
  switch (action.type) {
    case SELECT_SHIPPING_METHOD:
      return action.shippingMethodId;
    case SHIPPING_METHODS_UPDATED:
      return action.methods.some(method => method.Id === state) ? state : '';
    default:
      return state;
  }
}

export const isShippingPending = function(state = false, action) {
  switch (action.type) {
    case SHIPPING_METHODS_ARE_VALID:
      return !action.isValid;
    case SHIPPING_METHODS_UPDATED:
      return false;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Components/checkout/Features/ShippingMethod/shippingMethodReducers.js